require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-temporary-service-disruption.json") })
        }
      }, "path---es-articles-temporary-service-disruption");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-temporary-service-disruption!./.cache/json/es-articles-temporary-service-disruption.json
// module id = 2471
// module chunks = 231608221292675